export enum DatabasePropertyType {
  Text = 'text',
  LongText = 'long-text',
  Markdown = 'markdown',
  Number = 'number',
  Boolean = 'boolean',
  Dropdown = 'dropdown',

  Date = 'date',
  Time = 'time',
  DateRange = 'date-range',

  Teleport = 'teleport',
  ReverseRelation = 'reverse-relation',
  Relation = 'relation',
  Formula = 'formula',

  Phone = 'phone',
  Location = 'location',
  Mail = 'mail',
  Link = 'link',

  People = 'people',
  Rating = 'rating',
  Comments = 'comments',
  Files = 'files',
  Status = 'status',

  RowId = 'id',
  AutoId = 'auto-id',
  RandomId = 'random-id',
  TimeTracker = 'time-tracker',

  CreatedAt = 'created-at',
  UpdatedAt = 'updated-at',

  Checklist = 'checklist',
  Vote = 'vote',
  Button = 'button',
  Watchers = 'watchers',
}
